import { Box, Button, Flex, Icon, IconButton, Text } from '@chakra-ui/react';
import { useAtomValue } from 'jotai';
import { IoMdClose } from 'react-icons/io';

import {
  CustomerNotification,
  DismissCustomerNotificationMutationFn,
} from '../../../gql/generated/graphql';
import { relativeFormat } from '../../../utils/dates';
import { dashboardDealInfoAtom } from '../RootDashboard';

interface Props {
  notification: CustomerNotification;
  dismissNotification: DismissCustomerNotificationMutationFn;
  showDismissed: boolean;
  setOpenNotificationModal: (a: string | null) => void;
}

const NotificationItem = ({
  notification,
  dismissNotification,
  showDismissed,
  setOpenNotificationModal,
}: Props) => {
  const dealId = useAtomValue(dashboardDealInfoAtom);

  const handleDismiss = (id: CustomerNotification['id']) => {
    if (!id || !dealId?.id) return;

    dismissNotification({
      variables: {
        id,
        dealId: dealId.id,
        isCobuyer: dealId?.isCobuyer ?? false,
      },
    });
  };

  const callToActions = notification.call_to_actions;
  const showDismissButton =
    !showDismissed && (!notification.call_to_actions || notification.call_to_actions.length === 0);

  return (
    <Flex justifyContent="space-between" w="full" mb={2} p={3} bg="gray.50" rounded="md">
      <Box>
        <Text fontWeight="semibold">{notification.content}</Text>
        <Text mt={2} fontSize="sm">
          {relativeFormat(notification.created_at)}
        </Text>
      </Box>
      {callToActions?.map((callToAction) => (
        <Box ml={{ base: 4, md: 2 }} key={callToAction?.action}>
          <Button
            variant="secondary"
            size="xs"
            fontSize="xs"
            onClick={() => setOpenNotificationModal(callToAction?.action || null)}
          >
            {callToAction?.label}
          </Button>
        </Box>
      ))}
      {showDismissButton && (
        <IconButton
          aria-label="Dismiss notification"
          variant="ghost"
          size="xs"
          onClick={() => handleDismiss(notification.id)}
          icon={<Icon as={IoMdClose} boxSize="15px" color="gray.400" />}
        />
      )}
    </Flex>
  );
};

export default NotificationItem;
